import dayjs from 'utils/dayjs'

export default function relativeTime(date) {
  return date ? dayjs(date).utc().fromNow() : '–'
}
